import { render, staticRenderFns } from "./dyh-onlineclass.vue?vue&type=template&id=645c3eb2&scoped=true&"
import script from "./dyh-onlineclass.vue?vue&type=script&lang=js&"
export * from "./dyh-onlineclass.vue?vue&type=script&lang=js&"
import style0 from "./dyh-onlineclass.vue?vue&type=style&index=0&id=645c3eb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645c3eb2",
  null
  
)

export default component.exports